import { render, staticRenderFns } from "./ExternalButton.vue?vue&type=template&id=2a1005a0&scoped=true&"
import script from "./ExternalButton.vue?vue&type=script&lang=js&"
export * from "./ExternalButton.vue?vue&type=script&lang=js&"
import style0 from "./ExternalButton.vue?vue&type=style&index=0&id=2a1005a0&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a1005a0",
  null
  
)

export default component.exports